import { EstructuraComision } from '../types';

// ── Cálculo de comisión por aportación ───────────────────────────────────────

export function calcularComisionAportacion(
  comision: EstructuraComision,
  fechaInicio: Date,
  fechaAportacion: Date,
  cantidad: number,
): { porcentaje: number; comisionAplicada: number; cantidadInvertida: number } {
  if (comision.tipo === 'ninguna') {
    return { porcentaje: 0, comisionAplicada: 0, cantidadInvertida: cantidad };
  }

  if (comision.tipo === 'porcentaje_fijo') {
    const pct = comision.porcentajeFijo ?? 0;
    const com = Number((cantidad * pct / 100).toFixed(2));
    return { porcentaje: pct, comisionAplicada: com, cantidadInvertida: Number((cantidad - com).toFixed(2)) };
  }

  if (comision.tipo === 'escalonada' && comision.tramos && comision.tramos.length > 0) {
    const MS_ANIO = 365.25 * 24 * 60 * 60 * 1000;
    const anios = (fechaAportacion.getTime() - fechaInicio.getTime()) / MS_ANIO;
    const sorted = [...comision.tramos].sort((a, b) => a.aniosHasta - b.aniosHasta);
    const tramo = sorted.find(t => anios <= t.aniosHasta) ?? sorted[sorted.length - 1];
    const pct = tramo.porcentaje;
    const com = Number((cantidad * pct / 100).toFixed(2));
    return { porcentaje: pct, comisionAplicada: com, cantidadInvertida: Number((cantidad - com).toFixed(2)) };
  }

  return { porcentaje: 0, comisionAplicada: 0, cantidadInvertida: cantidad };
}

// ── Labels e iconos ──────────────────────────────────────────────────────────

export const TIPO_INVERSION_LABEL: Record<string, string> = {
  etf:           'ETF',
  acciones:      'Acciones',
  fondo:         'Fondo',
  cripto:        'Cripto',
  deposito:      'Depósito',
  plan_pensiones:'Plan de Pensiones',
  ipa:           'IPA',
  crowdlending:  'Crowdlending',
  inmueble:      'Inmueble',
  otro:          'Otro',
};

export const TIPO_INVERSION_ICON: Record<string, string> = {
  etf:           '📈',
  acciones:      '📊',
  fondo:         '💼',
  cripto:        '₿',
  deposito:      '🏦',
  plan_pensiones:'🏗️',
  ipa:           '🛡️',
  crowdlending:  '🤝',
  inmueble:      '🏠',
  otro:          '💰',
};

// Tramos IPA por defecto (configurable por el usuario)
export const TRAMOS_IPA_DEFAULT = [
  { aniosHasta: 4,   porcentaje: 19 },
  { aniosHasta: 999, porcentaje: 3  },
];
